import { useUserConfig } from '@/features/user-config';

const DEFAULT_DATE_FORMAT = { label: '14-Mar-25', value: 'dd-MMM-yy' };

const useUserDateFormat = () => {
  const { data } = useUserConfig();
  return data?.dateFormat ?? DEFAULT_DATE_FORMAT;
};

export default useUserDateFormat;
